export const incidentOptions = [
  { value: 10, label: "Acidente" },
  { value: 11, label: "Defeito Mecânico" },
  { value: 12, label: "Vandalismo" },
  { value: 13, label: "Problema de Conservação" },
  { value: 14, label: "Outros incidentes" }
];
